import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, change as changeFieldValue } from "redux-form";
import { FormattedMessage, intlShape } from "react-intl";
import RecievablesSection from "./formSections/RecievablesSection";
import PayblesSection from "./formSections/PayablesSection";
import BusinessUnitsSection from "./formSections/BusinessUnitsSection";
import * as dataActions from "../../../../utils/data/dataActions";
import ValidationUtils from "../../../../utils/ValidationUtils";
import { ACCOUNT_VALIDATION_RULES } from "./accountValidationRules";
import MultiSectionsModal from "../../../common/Modals/MultiSectionsModal";

class AccountsForm extends React.Component {
  static generateValidationRules(values) {
    let rules = {};
    const commonRules = {
      isRequiredTrim: {
        value: true,
      },
      maxLength: {
        value: 7,
      },
    };
    Object.keys(values.accountProvinces).forEach((accountProvinceId) => {
      rules[
        `accountProvinces['${accountProvinceId}'].insuranceTaxRecievable`
      ] = commonRules;
      rules[
        `accountProvinces['${accountProvinceId}'].insuranceTaxPayable`
      ] = commonRules;
      rules[
        `accountProvinces['${accountProvinceId}'].salesTaxMarkupPayable`
      ] = commonRules;
    });
    Object.keys(values.accountBusinessUnits).forEach(
      (accountBusinessUnitId) => {
        rules[
          `accountBusinessUnits['${accountBusinessUnitId}'].businessUnitAccount`
        ] = commonRules;
      }
    );

    return rules;
  }

  constructor(props, context) {
    super(props, context);

    this.renderButtons = this.renderButtons.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentWillMount() {
    this.resetForm();
  }

  renderButtons() {
    const { pristine, submitting, handleSubmit, onSubmit } = this.props;
    return (
      <span className="buttons">
        <button
          className="btn btn-primary"
          type="submit"
          disabled={pristine || submitting}
          onClick={handleSubmit(onSubmit)}
        >
          <FormattedMessage id="common.save" />
        </button>
        <button
          className="btn btn-default"
          type="button"
          onClick={this.resetForm}
        >
          <FormattedMessage id="common.cancel" />
        </button>
      </span>
    );
  }

  resetForm() {
    const { initialize, initialValues } = this.props;

    initialize(initialValues);
  }

  render() {
    const {
      handleSubmit,
      invalid,
      provinces,
      businessUnit,
      onSubmit,
    } = this.props;

    return (
      <div className="accounts">
        <MultiSectionsModal
          bodyClasses="InsurerModalBody"
          disableNavigation={invalid}
          revealErrors={handleSubmit}
          handleSubmit={onSubmit}
        >
          {[
            {
              sectionName: (
                <FormattedMessage id="admin.accounts.recievables.title" />
              ),
              section: <RecievablesSection provinces={provinces} />,
            },
            {
              sectionName: (
                <FormattedMessage id="admin.accounts.payables.title" />
              ),
              section: <PayblesSection provinces={provinces} />,
            },
            {
              sectionName: (
                <FormattedMessage id="admin.accounts.businessunits.title" />
              ),
              section: <BusinessUnitsSection businessUnit={businessUnit} />,
            },
          ]}
        </MultiSectionsModal>
        {this.renderButtons()}
      </div>
    );
  }
}

AccountsForm.propTypes = {
  authLanguageCode: PropTypes.string,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  initialValues: PropTypes.object,
  loaded: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  invalid: PropTypes.bool,
  dataActions: PropTypes.object,
  provinces: PropTypes.array,
  businessUnit: PropTypes.array,
};

AccountsForm.contextTypes = {
  intl: intlShape,
};

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "accountsForm",
    enableReinitialize: true,
    validate: (values) =>
      ValidationUtils.validate(values, {
        ...ACCOUNT_VALIDATION_RULES,
        ...AccountsForm.generateValidationRules(values),
      }),
  })(AccountsForm)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/AccountsForm.js